export default {
    seo: {
      title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами | Банк 131',
      description: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами'
    },
    title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами',
    content: [
      {
        label: 'Дата размещения 15.10.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за сентябрь 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_September_2026.pdf',
      },
      {
        label: 'Дата размещения 15.09.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за август 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_August_2026.pdf',
      },
      {
        label: 'Дата размещения 14.08.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июль 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_July_2026.pdf',
      },
      {
        label: 'Дата размещения 14.07.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июнь 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_June_2026.pdf',
      },
      {
        label: 'Дата размещения 15.06.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за май 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_May_2026.pdf',
      },
      {
        label: 'Дата размещения 19.05.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за апрель 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_April_2026.pdf',
      },
      {
        label: 'Дата размещения 14.04.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за март 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_march_2026.pdf',
      },
      {
        label: 'Дата размещения 16.03.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за февраль 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_february_2026.pdf',
      },
      {
        label: 'Дата размещения 13.02.26',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за январь 2026.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_january_2026.pdf',
      },
      {
        label: 'Дата размещения 21.01.2026',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за декабрь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_December_2025.pdf',
      },
      {
        label: 'Дата размещения 09.12.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за ноябрь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_November_2025.pdf',
      },
      {
        label: 'Дата размещения 13.11.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за октябрь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_October_2025.pdf',
      },
      {
        label: 'Дата размещения 14.10.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за сентябрь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_September_2025.pdf',
      },
      {
        label: 'Дата размещения 11.09.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за август 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_August_2025.pdf',
      },
      {
        label: 'Дата размещения 12.08.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июль 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_July_2025.pdf',
      },
      {
        label: 'Дата размещения 15.07.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июнь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_June_2025.pdf',
      },
      {
        label: 'Дата размещения 18.06.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за май 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_May_2025.pdf',
      },
      {
        label: 'Дата размещения 21.05.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за апрель 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_April_2025.pdf',
      },
      {
        label: 'Дата размещения 15.04.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за март 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_March_2025.pdf',
      },
      {
        label: 'Дата размещения 13.03.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за февраль 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_February_2025.pdf',
      },
      {
        label: 'Дата размещения 12.02.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за январь 2025.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_January_2025.pdf',
      },
      {
        label: 'Дата размещения 22.01.2025',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за декабрь 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_December_2024.pdf',
      },
      {
        label: 'Дата размещения 12.12.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за ноябрь 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_November_2024.pdf',
      },
      {
        label: 'Дата размещения 14.11.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за октябрь 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_October_2024.pdf',
      },
      {
        label: 'Дата размещения 15.10.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за сентябрь 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_September_2024.pdf',
      },
      {
        label: 'Дата размещения 12.09.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за август 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_August_2024.pdf',
      },
      {
        label: 'Дата размещения 13.08.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июль 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_July_2024.pdf',
      },
      {
        label: 'Дата размещения 11.07.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за июнь 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_June_2024.pdf',
      },
      {
        label: 'Дата размещения 11.06.2024',
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами за май 2024.pdf',
        link: '/legal/ru/information_on_interest_rates_on_bank_deposit_agreements_with_individuals_for_May_2024.pdf',
      },
    ],
}